import { createTemplate } from '../../../../../helpers/template';

export default (mask, url) => {
  const slices = url.split('/').reverse();
  const episode = slices[0];
  const program = slices[1];
  return createTemplate(mask)({ program, episode });
};
